/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function SearchIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "search", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 10.5, cy: 10.5, r: 5, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M14 14L20 20", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(SearchIcon);
export default ForwardRef;
//# sourceMappingURL=searchIcon.js.map